import Camera  from './Camera3D';
// import Vector2 from '../../math/Vector2';

export default class PerspectiveCamera extends Camera {
	private _fov: number;
	private _aspect: number;

	constructor (fov: number = Math.PI / 2, aspect: number = 1, near?: number, far?: number) {
		super(near, far);

		this._fov = fov;
		this._aspect = aspect;

		this._setProjection();
	}

	_setProjection () {
		this._projectionMatrix.setPerspectiveProjection(this._fov, this._aspect, this._near, this._far);
	}

	getHeight (distance: number) {
		return Math.tan(this._fov / 2) * distance;
	}

	get fov () {
		return this._fov;
	}

	set fov (fov: number) {
		this._fov = fov;
		this._setProjection();
	}

	setAspect (aspect: number) {
		this._aspect = aspect;
		this._setProjection();
	}

	getAspect () {
		return this._aspect;
	}

	updateBounds (viewWidth: number, viewHeight: number) {
		var farPlaneHeightOver2 = this._far * Math.tan(this._fov * 0.5)// / viewHeight;
		var farPlaneWidthOver2  = farPlaneHeightOver2 * viewWidth / viewHeight;

		// Camera position
		var x0 = this.position.x;
		var y0 = this.position.y;
		var z0 = this.position.z;

		// Center of the far plane
		var farCenterX = x0 + this._far * this.forward.x;
		var farCenterY = y0 + this._far * this.forward.y;
		var farCenterZ = z0 + this._far * this.forward.z;

		// Vector from center to the right middle point of the far plane
		var farRightX = farPlaneWidthOver2 * this.rightward.x;
		var farRightY = farPlaneWidthOver2 * this.rightward.y;
		var farRightZ = farPlaneWidthOver2 * this.rightward.z;

		// Vector from center to the upper middle point of the far plane
		var farUpX = farPlaneHeightOver2 * this.upward.x;
		var farUpY = farPlaneHeightOver2 * this.upward.y;
		var farUpZ = farPlaneHeightOver2 * this.upward.z;

		// Points on far plane
		var x1 = farCenterX - farRightX - farUpX;
		var x2 = farCenterX + farRightX - farUpX;
		var x3 = farCenterX - farRightX + farUpX;
		var x4 = farCenterX + farRightX + farUpX;

		var y1 = farCenterY - farRightY - farUpY;
		var y2 = farCenterY + farRightY - farUpY;
		var y3 = farCenterY - farRightY + farUpY;
		var y4 = farCenterY + farRightY + farUpY;

		var z1 = farCenterZ - farRightZ - farUpZ;
		var z2 = farCenterZ + farRightZ - farUpZ;
		var z3 = farCenterZ - farRightZ + farUpZ;
		var z4 = farCenterZ + farRightZ + farUpZ;

		this.bounds[0] = Math.min(x0, x1, x2, x3, x4);
		this.bounds[1] = Math.max(x0, x1, x2, x3, x4);
		this.bounds[2] = Math.min(y0, y1, y2, y3, y4);
		this.bounds[3] = Math.max(y0, y1, y2, y3, y4);
		this.bounds[4] = Math.min(z0, z1, z2, z3, z4);
		this.bounds[5] = Math.max(z0, z1, z2, z3, z4);
	}
}
